export const dictionaryEN = {
  Book: "Book",
  Continue: "Continue",
  "Continue to checkout": "Continue to checkout",
  "/hr": "/hr",
  people: "people",
  person: "person",
  Location: "Location",
  "City: Any": "City: Any",
  "State: Any": "State: Any",
  "Location: Any": "Location: Any",
  "Capacity: Any": "Capacity: Any",
  Filter: "Filter",
  Filters: "Filters",
  "{numberOfRooms} rooms found": "{numberOfRooms} rooms found",
  Office: "Office",
  Any: "Any",
  "Any location": "Any",
  "Any city": "Any",
  view: "view",
  "Invitations already sent to:": "Invitations already sent to:",
  and: "and",
  "Available on": "Available on",
  "Available on {date}": "Available on {date}",
  "No available space": "No available space",
  "View More": "View More",
  "Additional offices at this location": "Additional offices at this location",
  Floor: "Floor",
  "With window": "With window",
  "Day offices at-{locationName}": "Day offices at-{locationName}",
  "Not sure?": "Not sure?",
  "Talk with us": "Talk with us",
  "We are sorry, but there is no availability for 1 pass":
    "We are sorry, but there is no availability for 1 pass",
  "We are sorry, but there is no availability for {number of passes} passes":
    "We are sorry, but there is no availability for {number of passes} passes",
  "and we may be able to help you find a solution.":
    "and we may be able to help you find a solution.",
  max: "max",
  "Have more questions?": "Have more questions?",
  "Visit our FAQ": "Visit our FAQ",
  "Frequently asked questions": "Frequently asked questions",
  Directions: "Directions",
  "is located at": "is located at",
  "Not available": "Not available",
  Total: "Total",
  to: "to",
  "/day": "/day",
  "/hour": "/hour",
  "Quantity:": "Quantity:",
  Quantity: "Quantity",
  Save: "Save",
  When: "When",
  Back: "Back",
  "Please select a location": "Please select a location",
  "Please select date range": "Please select date range",
  "Please select # of entries": "Please select # of entries",
  "Please select date": "Please select date",
  "Please select time": "Please select time",
  "Please select duration": "Please select duration",
  "Please select quantity": "Please select quantity",
  day: "day",
  days: "days",
  "1 day": "1 day",
  "{number of days} days": "{number of days} days",
  "1 hour": "1 hour",
  "{number of hours} hours": "{number of hours} hours",
  "1 entry": "1 entry",
  "{number of entries} entries": "{number of entries} entries",
  entry: "entry",
  entries: "entries",
  hour: "hour",
  hours: "hours",
  Close: "Close",
  Update: "Update",
  Amenities: "Amenities",
  "Powered by": "Powered by",
  Privacy: "Privacy",
  Terms: "Terms",
  QTY: "QTY",
  Subtotal: "Subtotal",
  "Cancel for free up to {duration} before your booking":
    "Cancel for free up to {duration} before your booking",
  "Cancel for free up to ": "Cancel for free up to ",
  "Fits: {capacity} people max": "Fits: {capacity} people max",
  "Free cancellation before {time} on {date}":
    "Free cancellation before {time} on {date}",
  "Non refundable.": "Non refundable.",
  "{max} max": "{max} max",
  "Up to {capacity} people": "Up to {capacity} people",
  "Up to {capacity} person": "Up to {capacity} person",
  "End time": "End time",
  "Start time": "Start time",
  "View all images": "View all images",
  "Full name": "Full name",
  "Phone number": "Phone number",
  Email: "Email",
  "Number of expected guests": "Number of expected guests",
  "Company Name": "Company Name",
  "Street address": "Street address",
  "City / Town": "City / Town",
  "State / Province / Region (optional)":
    "State / Province / Region (optional)",
  "Postal code": "Postal code",
  Country: "Country",
  "Tax / VAT / ID number": "Tax / VAT / ID number",
  "Enter a promo code": "Enter a promo code",
  "Promo code": "Promo code",
  "Payment details": "Payment details",
  "Confirm and Pay": "Confirm and Pay",
  "Continue to payment": "Continue to payment",
  "This crash has been reported to us and we will work on resolving the issue as quickly as possible.":
    "This crash has been reported to us and we will work on resolving the issue as quickly as possible.",
  "By clicking on Confirm and Pay I agree to the":
    "By clicking on Confirm and Pay I agree to the",
  "terms and conditions": "terms and conditions",
  "Billing details": "Billing details",
  "Your details": "Your details",
  "Check here to indicate that you have read and agreed to the":
    "Check here to indicate that you have read and agreed to the",
  Apply: "Apply",
  "Submitting your request": "Submitting your request",
  "Please add your full name": "Please add your full name",
  "Please agree to the terms and conditions":
    "Please agree to the terms and conditions",
  "Please add your company name": "Please add your company name",
  "Please add your phone number": "Please add your phone number",
  "Please enter valid phone number": "Please enter valid phone number",
  "Please add your email": "Please add your email",
  "Please enter valid email": "Please enter valid email",
  "Please add billing street address": "Please add billing street address",
  "Please add billing city": "Please add billing city",
  "Please add postal code": "Please add postal code",
  "Please add billing country": "Please add billing country",
  "Please add tax information": "Please add tax information",
  "Please enter credit card info": "Please enter credit card info",
  "Let's talk": "Let's talk",
  "We would be happy to provide you with more information and answer your specific office needs.":
    "We would be happy to provide you with more information and answer your specific office needs.",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "How can we help?": "How can we help?",
  Submit: "Submit",
  "Could not get order confirmation": "Could not get order confirmation",
  "Stripe was not loaded": "Stripe was not loaded",
  "The session has expired. Please refresh the page and try again.":
    "The session has expired. Please refresh the page and try again.",
  "Card component not found": "Card component not found",
  "Payment unsuccessful": "Payment unsuccessful",
  "Redirecting you to confirmation page":
    "Redirecting you to confirmation page",
  Payment: "Payment",
  "Confirmed without payment": "Confirmed without payment",
  "N/A": "N/A",
  "Ending with {last4}": "Ending with {last4}",
  "Confirmed!": "Confirmed!",
  "Thank you for booking with us. A confirmation email has been sent to {email}. We are looking forward to seeing you soon.":
    "Thank you for booking with us. A confirmation email has been sent to {email}. We are looking forward to seeing you soon.",
  "Payment method": "Payment method",
  "Phone (optional)": "Phone (optional)",
  "Please enter at least one attendee.": "Please enter at least one attendee.",
  "Invite Attendees": "Invite Attendees",
  Message: "Message",
  Name: "Name",
  "i.e. Meet me at {offeringName} for our meeting at 0930.":
    "i.e. Meet me at {offeringName} for our meeting at 0930.",
  "Fill in the information below to send an email invitation to your attendees with details and directions.":
    "Fill in the information below to send an email invitation to your attendees with details and directions.",
  "View Invitation": "View Invitation",
  "Will there be others joining you?": "Will there be others joining you?",
  attendee: "attendee",
  attendees: "attendees",
  "Please add email": "Please add email",
  "Please add name": "Please add name",
  "Invitation sent!": "Invitation sent!",
  "An email invitation have been sent to your attendees with details and directions.":
    "An email invitation have been sent to your attendees with details and directions.",
  Attendees: "Attendees",
  "Attendees:": "Attendees:",
  Done: "Done",
  "Invitation sent to 1 attendee": "Invitation sent to 1 attendee",
  "Invitation sent to {number of attendees} attendees":
    "Invitation sent to {number of attendees} attendees",
  "{number of hours}": "{number of hours}",
  "{number of entries}": "{number of entries}",
  "{number of days}": "{number of days}",
  "Sorry, we couldn’t find anything matching your search.":
    "Sorry, we couldn’t find anything matching your search.",
  "Reset Filter": "Reset Filter",
  "Select a location": "Select a location",
  "Select quantity": "Select quantity",
  "Select number of guests": "Select number of guests",
  "Select # of entries": "Select # of entries",
  "{productTypeName} to {locationName}": "{productTypeName} to {locationName}",
  Capacity: "Capacity",
  "Capacity:": "Capacity:",
  "Image for illustration purpose only": "Image for illustration purpose only",
  "Send Invitations": "Send Invitations",
  ILS: "ILS",
  "on {cancelledAt}.": "on {cancelledAt}.",
  "Order cancelled": "Order cancelled",
  "Cancelled and refunded ": "Cancelled and refunded ",
  "Cancel Order": "Cancel Order",
  Cancellation: "Cancellation",
  "Are you sure you want to cancel and get a refund? This cannot be un-done.":
    "Are you sure you want to cancel and get a refund? This cannot be un-done.",
  "No, do not cancel": "No, do not cancel",
  "Yes, Cancel & Refund": "Yes, Cancel & Refund",
  "Or call us at:": "Or call us at:",
  "Additional Products": "Additional Products",
  "Book now": "Book now",
  "Subscribe now": "Subscribe now",
  "Coming Soon": "Coming Soon",
  "Manage bookings": "Manage bookings",
  "Learn more": "Learn more",
  Daily: "Daily",
  "Daily (1 pass)": "Daily (1 pass)",
  Confirm: "Confirm",
  "Start from": "Start from",
  "There are no offices available for the selected capacity.":
    "There are no offices available for the selected capacity.",
  Date: "Date",
  Clear: "Clear",
  "Our Customers Say": "Our Customers Say",
  "Review from Google": "Review from Google",
  phoneNumberOptional: "Phone number (optional)",
  "Please add your first name": "Please add your first name",
  "Please add your last name": "Please add your last name",
  "Please enter a valid email": "Please enter a valid email",
  "Please enter a valid phone number": "Please enter a valid phone number",
  "Message can't be blank": "Message can't be blank",
  bookingReasonTitle: "What is the purpose of your booking",
  bookingReasonTitleOptional: "What is the purpose of your booking? (Optional)",
  missingBookingReasonError: "Please add the purpose of your booking",
  bookingReason: "Booking Reason",
  selectADate: "Select a Date",
  "More to explore...": "More to explore...",
  backTo: "Back to",
  showFewerAmenities: "Show fewer amenities",
  showAllAmenities: "Show all amenities",
  needHelp: "Need help?",
  Guest: "Guest",
  Guests: "Guests",
  "Guest {capacity}": "{capacity} Guest",
  "Guests {capacity}": "{capacity} Guests",
  copy: "Copy",
  copied: "Copied",
  generalInformation: "General Information",
  "Single pass": "Single pass",
  "Select capacity": "Select capacity",
  "Enter a code": "Enter a code",
  "Update booking details": "Update booking details",
  "Select booking details": "Select booking details",
  "Book this space": "Book this space",
  "Check availability": "Check availability",
  "Select date": "Select date",
  City: "City",
  "Select a city": "Select a city",
  "Book here": "Book here",
  somethingWentWrong: "Something went wrong",
  availabilityFetchingError:
    "We're unable to check available rooms at this moment, please try again later.",
  "Cancellation policy": "Cancellation policy",
  "Payment information": "Payment information",
  "Thank you {firstName}, we will get back to you as soon as we can and reply to your email at {email}.":
    "Thank you {firstName}, we will get back to you as soon as we can and reply to your email at {email}.",
  "By providing your card information, you allow {partnerName} to charge your card for future payments in accordance with their ":
    "By providing your card information, you allow {partnerName} to charge your card for future payments in accordance with their ",
  "Terms of Service": "Terms of Service",
  share: "Share",
  backToAllOffering: "Back to All Offerings",
  backToAllMemberships: "Back to all memberships",
  Accessibility: "Accessibility",
  priceInfoMessage: "Price is based on availability",
  priceInfoMessageV2: "Price varies by availability.",
  priceChargedMessage: "You won’t be charged yet.",
  from: "from",
  "Already have a reservation": "Already have a reservation?",
  Yes: "Yes",
  No: "No",
  "You are now a {partnerName} member. A confirmation email has been sent to {email} with further instructions to activate your membership. We are looking forward to seeing you soon.":
    "You are now a {partnerName} member. A confirmation email has been sent to {email} with further instructions to activate your membership. We are looking forward to seeing you soon.",
  "Welcome to {partnerName}!": "Welcome to {partnerName}!",
  "We’ve chosen the best possible price for you based on your selections":
    "We’ve chosen the best possible price for you based on your selections",
  "Available spaces": "Available spaces",
  "Here are some additional spaces you might be interested in, available during our working hours 09:00-17:30":
    "Here are some additional spaces you might be interested in, available during our working hours 09:00-17:30",
  "To get the most out of your Coworking membership, you’ll need to activate your member portal. To get started, click the button below to set your password and login.":
    "To get the most out of your Coworking membership, you’ll need to activate your member portal. To get started, click the button below to set your password and login.",
  "To access your member portal, login with the same credentials you used for your multi passes.":
    "To access your member portal, login with the same credentials you used for your multi passes.",
  "Login to your member portal to access your new membership.":
    "Login to your member portal to access your new membership.",
  "Activate your member portal": "Activate your member portal",
  "Set my password": "Set my password",
  Login: "Login",
  "Book {numberOfHours}+ hours, save {savingValue} on select dates":
    "Book {numberOfHours}+ hours, save {savingValue} on select dates",
  "Membership options": "Membership options",
  Locations: "Locations",
  "Book {numberOfHours}+ hours to unlock {savingDisplay} off.":
    "Book {numberOfHours}+ hours to unlock {savingDisplay} off.",
  "before VAT per day": " before VAT /day",
  "before VAT per hour": " before VAT /hour",
  "before VAT": " before VAT",
  "You're saving {price}": "You're saving {price}",
  "Clear filters": "Clear filters",
  "Need more flexibility? Discover the benefits of memberships today!":
    "Need more flexibility? Discover the benefits of memberships today!",
  "See details": "See details",
  Where: "Where",
  Anywhere: "Anywhere",
  "{numberOfCities} cities, {numberOfBuildings} buildings":
    "{numberOfCities} cities, {numberOfBuildings} buildings",
  "Clear selection": "Clear selection",
  "See results": "See results",
  "Search for a city": "Search for a city",
  "Book {numberOfHours}+ hours, save {savingDisplay}":
    "Book {numberOfHours}+ hours, save {savingDisplay}",
  min: "min",
  mins: "mins",
  "1 hr": "1 hr",
  "{numberOfHours} hrs": "{numberOfHours} hrs",
  "{numberOfMinutes} mins": "{numberOfMinutes} mins",
  "You're saving {savingDisplay}!": "You're saving {savingDisplay}!",
  "First {cycles} months payment": "First {cycles} months payment",
  "After the initial month, you'll be billed {amount}/month on or about the first of the month.":
    "After the initial month, you'll be billed {amount}/month on or about the first of the month.",
  "Your {savingDisplay} off code is": "Your {savingDisplay} off code is",
  "Get {savingDisplay} off your next order!":
    "Get {savingDisplay} off your next order!",
  "Sign up to receive exclusive promotions and discounts, and receive {savingDisplay} off your next order!":
    "Sign up to receive exclusive promotions and discounts, and receive {savingDisplay} off your next order!",
  "{savingDisplay} off applied at checkout":
    "{savingDisplay} off applied at checkout",
  "Get {savingDisplay} Off!": "Get {savingDisplay} Off!",
  "We'll show rooms that fit": "We'll show rooms that fit",
  "and more spacious options if available.":
    "and more spacious options if available.",
  "{count}+ guests": "{count}+ guests",
  "{count}+ people": "{count}+ people",
  "Maximum capacity is {max} guests.": "Maximum capacity is {max} guests.",
  "Our meeting rooms fit up to {max} guests.":
    "Our meeting rooms fit up to {max} guests.",
  "event spaces": "event spaces",
  "Contact us": "Contact us",
  "For larger groups, explore our": "For larger groups, explore our",
  "for larger groups": "for larger groups",
  Who: "Who",
  "Any number of people": "Any number of people",
  "contact us": "contact us",
  or: "or",
  "Enter the minimum or expected number of people":
    "Enter the minimum or expected number of people",
  "Checkout session expired": "Checkout session expired",
  "Your checkout session has expired. Please refresh your page.":
    "Your checkout session has expired. Please refresh your page.",
  "Refresh Page": "Refresh Page",
  "Order is being disputed": "Order is being disputed",
  "Order was disputed": "Order was disputed",
  "Please add your membership number": "Please add your membership number",
  "Please enter only ten digits": "Please enter only ten digits",
  "Membership details": "Membership details",
  "Member ID Barcode": "Member ID Barcode",
};
